<template>
  <div class="deviceManage">
    <div class="header">
      <el-tabs value="first">
        <el-tab-pane label="SN管理" name="first">          
          <span class="childTabs" :class="{ activeLink: cutView == true }"
            @click="cutViewChange(true)">成品</span>
          <span class="childTabs" :class="{ activeLink: cutView == false }"
            @click="cutViewChange(false)">PCBA</span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small"
                  class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <!-- <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch">查询</el-button> -->
              <el-dropdown
                split-button
                type="primary"
                size="small"
                class="searchBox"  @click="onSearch(false)"
                trigger="click"
              >
                查询
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onSearch(true)">模糊查询</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                class="btn_more"
                :class="{activeUserMore:isMoreSearch}"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form v-if="cutView && isMoreSearch" :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input v-model="searchConditionForm.sn" placeholder="产品主SN" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="PCBA" size="small">
            <el-input v-model="searchConditionForm.pcba" placeholder="PCBA的SN" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="MAC" size="small">
            <el-input v-model="searchConditionForm.mac" placeholder="网卡、蓝牙的地址码" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="UUID" size="small">
            <el-input v-model="searchConditionForm.uuid" placeholder="P2P的UID或其他唯一标识" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="IMEI/ICCID" size="small">
            <el-input v-model="searchConditionForm.imei" placeholder="输入IMEI或ICCID" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="其它SN" size="small">
            <el-input v-model="searchConditionForm.otherSn" placeholder="输入其它SN" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="当前工序" size="small">
            <el-select
              v-model="searchConditionForm.workStationId"
              placeholder="选择当前工序"
              filterable
              clearable
              multiple
              collapse-tags
            >
              <el-option
                v-for="(item, index) in pullDownData.workStationsList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchConditionForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchConditionForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchConditionForm.customerId"
              placeholder="选择客户"
              filterable
              clearable
              @change="searchCustomerChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售订单" size="small">
            <el-select
              v-model="searchConditionForm.customerOrderId"
              placeholder="选择销售订单"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'customerOrder', '销售订单')"
              @change="searchCustomerOrderChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.customerOrderList"
                :key="index"
                :label="item.orderNumber"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内箱SN" size="small">
            <el-input v-model="searchConditionForm.innerCtnSn" placeholder="不支持模糊查询" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="外箱SN" size="small">
            <el-input v-model="searchConditionForm.outerCtnSn" placeholder="不支持模糊查询" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
          <el-form-item label="栈板SN" size="small">
            <el-input v-model="searchConditionForm.palletSn" placeholder="不支持模糊查询" clearable            
              @keyup.enter.native="getDeviceSearch()"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form v-if="!cutView && isMoreSearch" :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input v-model="searchConditionForm.sn" placeholder="PCBA SN" clearable            
              @keyup.enter.native="getPcbaSearch()"></el-input>
          </el-form-item>
          <el-form-item label="SMT工单" size="small">
            <el-input v-model="searchConditionForm.smtOrder" placeholder="SMT工单号" clearable            
              @keyup.enter.native="getPcbaSearch()"></el-input>
          </el-form-item>
          <el-form-item label="大板SN" size="small">
            <el-input v-model="searchConditionForm.parentSn" placeholder="大板SN" clearable            
              @keyup.enter.native="getPcbaSearch()"></el-input>
          </el-form-item>
          <el-form-item label="主控ID" size="small">
            <el-input v-model="searchConditionForm.chipId" placeholder="主控ID" clearable            
              @keyup.enter.native="getPcbaSearch()"></el-input>
          </el-form-item>
          <el-form-item label="当前工序" size="small">
            <el-select
              v-model="searchConditionForm.workStationId"
              placeholder="选择当前工序"
              filterable
              clearable
              multiple
              collapse-tags
            >
              <el-option
                v-for="(item, index) in pullDownData.workStationsList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="contentBox">
      <div v-if="cutView" class="rightContent">
        <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
          <el-table-column type="index" align="center"
            :width="pagination.endIndex >= 1000 ? 80:50" :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column prop="sn" label="SN" min-width="110" align="center" sortable="custom">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.sn"
                placement="top"
                :open-delay="300"
              >
                <div class="textOverflow allowSkip" v-if="scope.row.sn" @click="SNClickBtn($event, scope.row, 'device')">
                  <span class="allowSkip" :class="{disabled_device: scope.row.id<0}">{{scope.row.sn}}</span>
                </div>
              </el-tooltip>
              <span class="allowSkip" v-if="!scope.row.sn" @click="SNClickBtn($event, scope.row, 'device')">-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="pcbaSn"
            label="PCBA"
            min-width="110"
            align="center"
            sortable="custom"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.pcbaSn">{{scope.row.pcbaSn}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="uuid"
            label="UUID"
            min-width="110"
            align="center"
            sortable="custom"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.uuid" placement="top" :open-delay="300">
                <div class="textOverflow" v-if="scope.row.uuid">{{scope.row.uuid}}</div>
              </el-tooltip>
              <span v-if="!scope.row.uuid">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="mac" label="MAC" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" placement="top" :open-delay="300">
                <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.mac, null, 2) }}</div>
                <div class="textOverflow" v-if="scope.row.mac">{{scope.row.mac}}</div>
              </el-tooltip>
              <span v-if="!scope.row.mac">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="otherSn" label="其它SN" align="center">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.otherSn" class="item" effect="dark" placement="top" min-width="110px" :open-delay="300">
                <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.otherSn, null, 2) }}</div>
                <div class="textOverflow">
                  {{ scope.row.otherSn }}
                </div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="product" label="产品型号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.product">{{scope.row.product.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerId" label="客户" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="productionOrderId" label="工单信息" align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="top" :open-delay="300"
                  :content=" (scope.row.productionOrder? '【组装工单：'+scope.row.productionOrder.orderNumber+'】':'') + (scope.row.cartonOrder? '，【包装工单：'+scope.row.cartonOrder.orderNumber+'】':'') + (scope.row.shipmentOrder? '，【发货工单：'+scope.row.shipmentOrder.orderNumber+'】':'')">
                  <span class="textOverflow" v-if="scope.row.productionOrder">
                    {{ scope.row.productionOrder.orderNumber + (scope.row.cartonOrder? '，'+scope.row.cartonOrder.orderNumber:'') + (scope.row.shipmentOrder? '，'+scope.row.shipmentOrder.orderNumber:'')}}
                  </span>
                </el-tooltip>
                <span v-if="!scope.row.productionOrder">-</span>
              </template>
          </el-table-column>
          <el-table-column prop="productionOrderId" label="装箱信息" align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="top" :open-delay="300"
                  :content="'【内箱：'+(scope.row.innerCtnIndex>0 ? (scope.row.innerCtnIndex+'(SN:'+(scope.row.innerCtnSn ? scope.row.innerCtnSn : '-')+')'):'-')+'】'
                  +'【外箱：'+(scope.row.outerCtnIndex>0 ? (scope.row.outerCtnIndex+'(SN:'+(scope.row.outerCtnSn ? scope.row.outerCtnSn : '-')+')'):'-')+'】'
                  +'【栈板：'+(scope.row.palletIndex>0 ? (scope.row.palletIndex+'(SN:'+(scope.row.palletCtnSn ? scope.row.palletCtnSn : '-')+')'):'-')+'】'">
                  <span class="textOverflow" v-if="scope.row.productionOrder">
                    {{
                    '【内箱：'+(scope.row.innerCtnIndex>0 ? (scope.row.innerCtnIndex+'('+(scope.row.innerCtnSn ? scope.row.innerCtnSn : '-')+')'):'-')+'】'
                    +'【外箱：'+(scope.row.outerCtnIndex>0 ? (scope.row.outerCtnIndex+'('+(scope.row.outerCtnSn ? scope.row.outerCtnSn : '-')+')'):'-')+'】'
                    +'【栈板：'+(scope.row.palletIndex>0 ? (scope.row.palletIndex+'('+(scope.row.palletCtnSn ? scope.row.palletCtnSn : '-')+')'):'-')+'】'
                    }}
                  </span>
                </el-tooltip>
                <span v-if="!scope.row.productionOrder">-</span>
              </template>
          </el-table-column>
          <el-table-column prop="workStation" label="状态" width="95px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.workStation" class="textOverflow">{{scope.row.workStation.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>          
          <el-table-column prop="notes" label="备注" align="center">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.notes" class="item" effect="dark" :content="scope.row.notes" placement="top" :open-delay="800">
                <div class="textOverflow">              
                  <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
                    <i @click="addNotes($event, scope.row)" class="iconfont icon-pizhu"></i>
                  </el-tooltip>
                  {{ scope.row.notes }}
                </div>
              </el-tooltip>          
              <el-tooltip v-else class="item" effect="dark" content="修改" placement="top" :open-delay="300">
                <i @click="addNotes($event, scope.row)" class="iconfont icon-pizhu"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <pagination :pagination="pagination" @currentChange="currentChange" @sizeChange="sizeChange" @refreshBtn="getDeviceSearch"></pagination>
      </div>
      <div v-else class="rightContent">
        <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini"
        @sort-change="sortChange">
          <el-table-column type="index" align="center"
            :width="pagination.endIndex >= 1000 ? 80 : 50" :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column prop="sn" label="SN" align="center" sortable="custom" min-width="110px">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.sn ? scope.row.sn : '【未生成SN】'" placement="top" :open-delay="300">
                <span class="textOverflow allowSkip" @click="SNClickBtn($event, scope.row, 'pcba')">
                  {{ scope.row.sn ? scope.row.sn : "【未生成SN】" }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="SMT工单" align="center" min-width="110px">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.smtOrder && scope.row.smtOrder.orderNumber ? scope.row.smtOrder.orderNumber : '-'" placement="top" :open-delay="300">
                <span class="textOverflow">
                  {{ scope.row.smtOrder && scope.row.smtOrder.orderNumber ? scope.row.smtOrder.orderNumber : "-" }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="chipId" label="主控ID" align="center" min-width="160px">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.chipId" class="item" effect="dark" placement="top" :open-delay="300">
                <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.chipId, null, 2) }}</div>
                <span class="textOverflow">
                  {{ scope.row.chipId}}
                </span>
              </el-tooltip>          
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="otherSn" label="其它SN" align="center" min-width="160px">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.otherSn" class="item" effect="dark" placement="top" :open-delay="300">
                <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.otherSn, null, 2) }}</div>
                <span class="textOverflow">
                  {{ scope.row.otherSn}}
                </span>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="testTimes" label="直通" align="center" width="105px">
            <template slot-scope="scope">
              <span v-if="scope.row.sn && scope.row.testTimes && !scope.row.failTimes" class="textOverflow">是</span>
              <span v-else-if="scope.row.sn && !scope.row.testTimes && !scope.row.failTimes" class="textOverflow">-</span>
              <span v-else-if="scope.row.sn && scope.row.failTimes" class="textOverflow">否</span>
              <span v-else-if="!scope.row.sn" class="textOverflow">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="testTimes" label="测试次数" align="center" width="105px"
            sortable="custom">
            <template slot-scope="scope">
              <span class="textOverflow">{{ scope.row.testTimes }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="failTimes" label="错误次数" align="center" width="105px"
            sortable="custom">
            <template slot-scope="scope">
              <span class="textOverflow">{{ scope.row.failTimes }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="workStationId"
            label="状态"
            align="center"
            show-overflow-tooltip
            sortable="custom" width="135px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.workStation" class="textOverflow">{{
                scope.row.workStation.name
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="operation" label="操作" align="center" width="115px">
            <template slot-scope="scope">
              <!-- // 已发货的不能锁定 -->
              <span v-if="scope.row.workStation && scope.row.workStation.id=='36226401431584768'"
              > - </span>
              <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id!='-999'"
                          class="item" effect="dark" content="异常锁定" placement="top" :open-delay="300">
                <i @click="lockPcba($event, scope.row)" class="el-icon-lock"></i>
              </el-tooltip>
              <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id=='-999'"
                          class="item" effect="dark" content="解锁异常" placement="top" :open-delay="300">
                <i @click="unlockPcba($event, scope.row)" class="el-icon-unlock"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <pagination :pagination="pagination" @currentChange="currentChange" @sizeChange="sizeChange" @refreshBtn="getPcbaSearch"></pagination>
      </div>
    </div>
    <orderTableSelect ref="orderTableSelect" @orderTableSubmit="orderTableSubmit"></orderTableSelect>
    <myDrawer ref="myDrawer" :drawerOption="drawerOption"></myDrawer>
    <myDialog ref="myDialog" :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose" width="450px">
      <template slot="content">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="50px">
          <div v-if="dialogTitle === '添加备注'">            
            <el-form-item label="备注：" size="small" prop="notes">
              <el-input type="textarea"
                        :autosize="{minRows: 3, maxRows: 20}"
                        v-model="dialogForm.value"
                        placeholder="备注内容(只添加不修改)"
                        clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDrawer from "@/components/myDrawer.vue";
import myDialog from "@/components/myDialog.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import {
  apiDeviceSearch,
  apiPcbaSearch,
  apiProductTypeList,
  apiProductList,
  apiCustomerList,
  apiWorkStations,
  apiAddNotes
} from "@/api/deviceManage.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/deviceManage", subTabs: { cutView: [true, false] } },
  components: {
    pagination,
    myDrawer,
    myDialog,
    orderTableSelect
  },
  data() {
    return {
      isMoreSearch: false,
      searchConditionForm: {
        like: false
      },
      pullDownData: {
        productTypeList: [],
        productList: [],
        customerOrderList: [],
        productionOrderList: [],
        shipmentOrderList: [],
        customerList: [],
        workStationsList: [],
        processList: []
      },
      cutView: true,
      tableData: [],
      desc: undefined,
      orderBy: [],
      drawerOption: {
        currentSNId: "",
        currentSNName: "",
      },
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        customer_id: [
          { required: true, message: "客户名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change"
          }
        ],
        product_type: [
          { required: true, message: "产品类别不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change"
          }
        ],
        product_id: [
          { required: true, message: "内部型号不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change"
          }
        ],
        order_number: [
          { required: true, message: "销售单号不能为空！", trigger: "blur" }
        ],
        quantity: [
          { required: true, message: "裸机数量不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "change"
          }
        ]
      },
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    // 组装工单-切换视图
    cutViewChange(value) {
      this.cutView = value;
      if (value) {
        this.getDeviceSearch();
      } else {
        if (!this.pullDownData.workStationsList.length) {
          this.getWorkStationsList();
        }
        this.getPcbaSearch();
      }
      this.$moreSearchStyle();
    },
    addNotes(e, row) {
      this.dialogTitle = "添加备注";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id
      };
    },
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title === "添加备注") {
            res = await apiAddNotes(this.dialogForm);
          }
          if (res.code === 0) {
            this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.$refs.myDialog.dialogVisible = false;
            await this.getDeviceSearch();
          }
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    async getPcbaSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiPcbaSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据
    async getDeviceSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiDeviceSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 清除查询
    onClear() {
      this.searchConditionForm = {};
      this.pagination.currentPage = 1;
      if (this.cutView) {
        this.getDeviceSearch();
      } else {
        this.getPcbaSearch();
      }
    },
    // 确认查询
    onSearch(value) {
      this.searchConditionForm.like = value;
      this.pagination.currentPage = 1;
      if (this.cutView) {
        this.getDeviceSearch();
      } else {
        this.getPcbaSearch();
      }
    },
    // 查询条件-产品类别改变
    productTypeChange(value) {
      this.$set(this.searchConditionForm, "productId", undefined);
      this.pullDownData.productList = [];
      if (value) {
        this.getProductList(value, "productList");
      }
    },
    // 查询条件-客户改变
    searchCustomerChange() {
      this.$set(this.searchConditionForm, "customerOrderId", undefined);
      this.$set(this.searchConditionForm, "productionOrderId", undefined);
      this.$set(this.searchConditionForm, "shipmentOrderId", undefined);
    },
    // 查询条件-销售订单改变
    searchCustomerOrderChange() {
      this.$set(this.searchConditionForm, "productionOrderId", undefined);
    },
    // 查询条件-销售订单/组装工单/发货单
    selectVisible(value, orderName, labelName) {
      if (value) {
        // console.log(orderName, labelName)
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.parameter = {
          customerId: this.searchConditionForm.customerId,
          customerOrderId: this.searchConditionForm.customerOrderId
        };
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 订单表格提交
    orderTableSubmit({ orderName, selectRow }) {
      this.$set(this.searchConditionForm, `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
      // 查询条件-销售订单改变
      if (orderName == "customerOrder") {
        this.$set(this.searchConditionForm, "productionOrderId", undefined);
      }
    },
    // 点击sn列
    SNClickBtn(e, row, type) {
      e.target.blur();
      this.drawerOption = {
        currentSNId: row.id,
        currentSNName: row.sn || "-",
      }
      this.$nextTick(() => {
        if (type === 'pcba') {
          this.$refs.myDrawer.getPcbaSnLife();
        } else {
          this.$refs.myDrawer.getDeviceLife();
        }
      })
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      if (this.cutView) {
        this.getDeviceSearch();
      } else {
        this.getPcbaSearch();
      }
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      if (this.cutView) {
        this.getDeviceSearch();
      } else {
        this.getPcbaSearch();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      if (this.cutView) {
        this.getDeviceSearch();
      } else {
        this.getPcbaSearch();
      }
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    // 产品状态下拉
    async getWorkStationsList() {
      const res = await apiWorkStations();
      if (res.code == 0) {
        this.pullDownData.workStationsList = res.data;
      }
    },
    // 产品进程下拉
    // async getProcessList() {
    //   const res = await apiDeviceProcess();
    //   if (res.code == 0) {
    //     this.pullDownData.processList = res.data;
    //   }
    // },
    callback() {
      this.getProductTypeList();
      this.getCustomerList();
      this.getWorkStationsList();
      // this.getProcessList();
    }
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    // 根据当前 cutView 状态决定查询哪个视图的数据
    if (this.cutView) {
      this.getDeviceSearch("", this.callback);
    } else {
      this.getPcbaSearch();
    }
  },
  deactivated() {
    window.onresize = null;
  }
};
</script>

<style lang="less" scoped>
.disabled_device {
  text-decoration: line-through;
}
</style>